import { Component } from '@angular/core';
import { BUTTON_CANCEL, BUTTON_SAVE, DefaultFormDialogComponent } from '../../../../../shared/message/dialogs/default-form-dialog.component';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { Override } from '../../../../../shared/app-decorators';
import { ICodeValue } from '../../../../../../type_definitions/datatypes';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { LOV_OEM_ACSL_RANKING, LovService } from '../../../../../shared/services/lov.service';
import { FormattingService } from '../../../../../shared/services/formatting.service';

export interface IOEMChangeRankingModel {
  ranking:ICodeValue;
}

@Component({
  selector: 'oem-change-ranking-dialog',
  templateUrl: '../../../../../shared/message/dialogs/default-form-dialog.html'
})
export class OEMChangeRankingDialogComponent extends DefaultFormDialogComponent {
  public model:IOEMChangeRankingModel;

  private rankingField:IExtraFieldConfigurationObject;

  constructor(
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private lovService:LovService,
    protected validationService:GaValidateService,
    protected translationService:TranslationService
  ) {
    super(validationService, translationService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit():void {
    super.ngOnInit();

    this.replaceButtonLabels({
      [BUTTON_SAVE]: {
        translateText: 'GA.BUTTONS.CHANGE_LABEL',
        translateValues: { label: 'BPPROFILES.OEM.RANKING.LABEL' }
      },
      [BUTTON_CANCEL]: {
        translateText: 'GA.BUTTONS.DONT_LABEL',
        translateValues: { label: 'GA.BUTTONS.CHANGE' }
      }
    });

    // create fields
    this.fields = this.createFields();
    // fill fields
    this.fillFields();
  }

  private fillFields():void {
    this.formlyService.fillField(this.rankingField, this.lovService.list(LOV_OEM_ACSL_RANKING));
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';

    return [
      this.rankingField = this.formlyService.aSelect('ranking')
        .withFormat(this.formattingService.formatLov)
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .build()
    ];
  }
}